import { render, staticRenderFns } from "./Ingreso.vue?vue&type=template&id=0179c130&lang=pug"
import script from "./Ingreso.vue?vue&type=script&lang=js"
export * from "./Ingreso.vue?vue&type=script&lang=js"
import style0 from "./Ingreso.vue?vue&type=style&index=0&id=0179c130&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports